/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import {ServerTable, ClientTable, Event} from 'vue-tables-2-premium';
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';

import App from './App.vue';

// router setup
import router from './routes/router';
import store from './store/index'

// import './plugins/vue-notification';
// import './plugins/message-box';

import './plugins'

//import router from './routes/starterRouter';
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)


import JsonViewer from 'vue-json-viewer/ssr'
import 'vue-json-viewer/style.css'

// Import JsonViewer as a Vue.js plugin
Vue.use(JsonViewer)
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(ClientTable);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});
